import { render } from "./Detalhes.vue?vue&type=template&id=4bb51939&scoped=true"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"

import "./Detalhes.vue?vue&type=style&index=0&id=4bb51939&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb51939"]])

export default __exports__